import createHistory from 'history/createBrowserHistory';

import { apps } from '../config';

const history = createHistory();

const routeNaming = {
  ABOUT_US: 'aboutUs',
  BRAND_SERVICE: 'brandService',
  CART: 'cart',
  CHANGE_PASSWORD: 'changePassword',
  CHECKOUT: 'checkout',
  COMPARE: 'compare',
  CONDITIONS: 'conditions',
  CONTACT: 'contact',
  COORDINATION: 'coordination',
  FORGOT_PASSWORD: 'forgotPassword',
  GO_TO_NOT_FOUND: 'goToNotFound',
  HELP: 'help',
  HOME: 'home',
  INFORMATION_MENU_MOBILE: 'informationMenuMobile',
  JOIN_OUR_TEAM: 'joinOurTeam',
  LOGIN_VALIDATOR: 'loginValidator',
  LOGIN: 'login',
  MESSAGE: 'message',
  MY_ACCOUNT_MENU_MOBILE: 'myAccountMenuMobile',
  MY_ACCOUNT: 'myAccount',
  MY_FAVORITES: 'myFavorites',
  MY_ADDRESSES: 'myAddresses',
  MY_BILLING_DATA: 'myBillingData',
  MY_DATA: 'myData',
  MY_ORDERS: 'myOrders',
  MY_CREDITS: 'myCredits',
  MY_PHONE_NUMBERS: 'myPhoneNumbers',
  NOT_FOUND: 'notFound',
  PANAVOX_SERVICE: 'panavoxService',
  PAYMENT_METHODS_AND_BILLING: 'paymentMethodsAndBilling',
  PRODUCT_DETAIL: 'productDetail',
  BILLING_DETAIL: 'billingDetail',
  PRODUCT_INDEX: 'productIndex',
  PRODUCT_GROUP: 'productGroup',
  RECOVER_ACCOUNT: 'recoverAccount',
  REGISTER: 'register',
  SEARCH_RESULTS: 'searchResults',
  SERVICE_TRACKING: 'serviceTracking',
  SHIPPING: 'shipping',
  TERMS: 'terms',
  VENUES_AND_OPEN_HOURS: 'venuesAndOpenHours',
  CHECKOUT_BANK_SUMMARY: 'checkoutBankSummary',
};

const PATH_PARAM_REGEX = /:[^/]+/gi;
const determineRouteParams = (route) => {
  const newRoute = { ...route };
  const { path } = newRoute;
  // Extract the names of the parameters
  const pathMatch = path.match(PATH_PARAM_REGEX) || [];
  const pathParams = pathMatch.map(param => param.slice(1));
  newRoute.pathParams = pathParams || [];
  return newRoute;
};

const routes = [
  {
    app: apps.HOME,
    name: routeNaming.HOME,
    path: '/',
  },
  {
    app: apps.HOME,
    name: routeNaming.PRODUCT_DETAIL,
    path: '/products/:id',
  },
  {
    app: apps.HOME,
    name: routeNaming.PRODUCT_INDEX,
    path: '/categories/:subMenuId',
  },
  {
    app: apps.HOME,
    name: routeNaming.PRODUCT_GROUP,
    path: '/products-group/:groupId',
  },
  {
    app: apps.HOME,
    name: routeNaming.NOT_FOUND,
    path: '/404',
  },
  {
    app: apps.HOME,
    name: routeNaming.COMPARE,
    path: '/compare',
  },
  {
    app: apps.STATIC_PAGES,
    name: routeNaming.VENUES_AND_OPEN_HOURS,
    path: '/venues-and-open-hours',
  },
  {
    app: apps.STATIC_PAGES,
    name: routeNaming.INFORMATION_MENU_MOBILE,
    path: '/information-menu-mobile',
  },
  {
    app: apps.STATIC_PAGES,
    name: routeNaming.JOIN_OUR_TEAM,
    path: '/join-our-team',
  },
  {
    app: apps.STATIC_PAGES,
    name: routeNaming.ABOUT_US,
    path: '/about-us',
  },
  {
    app: apps.STATIC_PAGES,
    name: routeNaming.PANAVOX_SERVICE,
    path: '/panavox-service',
  },
  {
    app: apps.STATIC_PAGES,
    name: routeNaming.BRAND_SERVICE,
    path: '/brand-service',
  },
  {
    app: apps.STATIC_PAGES,
    name: routeNaming.SHIPPING,
    path: '/shipping',
  },
  {
    app: apps.STATIC_PAGES,
    name: routeNaming.HELP,
    path: '/help',
  },
  {
    app: apps.STATIC_PAGES,
    name: routeNaming.CONDITIONS,
    path: '/conditions',
  },
  {
    app: apps.STATIC_PAGES,
    name: routeNaming.CONTACT,
    path: '/contact',
  },
  {
    app: apps.STATIC_PAGES,
    name: routeNaming.SERVICE_TRACKING,
    path: '/service-tracking',
  },
  {
    app: apps.HOME,
    name: routeNaming.SEARCH_RESULTS,
    path: '/search',
  },
  {
    app: apps.STATIC_PAGES,
    name: routeNaming.TERMS,
    path: '/terms',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.CHECKOUT,
    path: '/checkout/:checkoutStep',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.LOGIN,
    path: '/login',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.COORDINATION,
    path: '/coordination/:checkoutId/:productId',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.CHECKOUT_BANK_SUMMARY,
    path: '/checkout-bank-summary',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.BILLING_DETAIL,
    path: '/billing-detail',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.LOGIN_VALIDATOR,
    path: '/login-validation',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.REGISTER,
    path: '/register',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.FORGOT_PASSWORD,
    path: '/forgot-password',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.FORGOT_PASSWORD,
    path: '/forgot-password',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.CHANGE_PASSWORD,
    path: '/password-change',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.RECOVER_ACCOUNT,
    path: '/recover-account',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.MY_ACCOUNT,
    path: '/my-account',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.MY_ADDRESSES,
    path: '/my-addresses',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.MY_ACCOUNT_MENU_MOBILE,
    path: '/my-account-menu-mobile',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.MY_DATA,
    path: '/my-data',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.MY_FAVORITES,
    path: '/my-favorites',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.MY_CREDITS,
    path: '/my-credit',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.MY_ORDERS,
    path: '/my-orders',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.MY_PHONE_NUMBERS,
    path: '/my-phone-numbers',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.CART,
    path: '/cart',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.MY_BILLING_DATA,
    path: '/my-billing-data',
  },
  {
    app: apps.CHECKOUT,
    name: routeNaming.PAYMENT_METHODS_AND_BILLING,
    path: '/payment-and-billing',
  },
  {
    app: apps.STATIC_PAGES,
    name: routeNaming.MESSAGE,
    path: '/message',
  },
  {
    app: apps.HOME,
    name: routeNaming.GO_TO_NOT_FOUND,
    path: '*',
  },
].map(determineRouteParams);

export {
  history,
  routeNaming,
  routes,
};



// WEBPACK FOOTER //
// ./src/routes/routes.js